export class AntwortText {
  typ: string;
  text: string;
}
